export default [
	{
		path: 'manage',
		name: 'm_digital',
		component: {
			render: h => h('router-view')
		},
		children: [{
			path: '',
			name: 'm_digital',
			component: () => import('@/pages/kanban/manage')
		}, {
			path: 'config/:id',
			meta: {
				title: '看板配置'
			},
			props: route => route.params,
			component: () => import('@/pages/kanban/config')
		}, {
			path: 'copy/:id',
			meta: {
				title: '复制看板'
			},
			props: route => Object.assign({copy: true}, route.params),
			component: () => import('@/pages/kanban/config')
		}]
	}
];